module.exports = __webpack_public_path__ + "img/home-white.3086994a.svg";